import { set } from 'lodash/fp';
import createReducer from '../../../helpers/createReducer';
import { fetchDownloadRequestsSearchOptions } from '../../sagas/routines';

const initialState = {
  users: [],
  fetching: false,
  fetched: false,
  fetchingError: null
};

export const fetchDownloadRequestsSearchOptionsHandler = routine => ({
  [routine.TRIGGER]: set('fetching', true),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    ...response
  }),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export default createReducer(initialState, {
  ...fetchDownloadRequestsSearchOptionsHandler(
    fetchDownloadRequestsSearchOptions
  )
});
